import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_dashboard/settings/_admin/stop-lists")({
  beforeLoad: async ({ context }) => {
    if (context.trialPeriod) throw redirect({ from: Route.fullPath, to: ".." });
  },
  staticData: {
    meta: {
      title: "Stoplister",
    },
  },
});
